<template>
  <section class="filter_wrapper" :style="`background-color: ${privateProps.moduleBackgroundColor};`">
    <div class="filter-bar" :class="{'hascity': privateProps.houseFilterMode==1}" :style="`background-color: ${privateProps.backgroundColor}; color: ${privateProps.textColor}`">
      <div class="city-field" @click="clickLocation" v-if="privateProps.houseFilterMode==1">
        <div class="city-name">{{isLocationLoading?'定位中...':(cityName||'选城市')}}</div>
        <div class="iconfont icon-solid-arrow" :style="`color: ${privateProps.textColor};`"></div>
      </div>
      <div class="hairline-border hairline-border-city" :style="`background-color: ${privateProps.textColor};`" v-if="privateProps.houseFilterMode==1"></div>
      <div class="date-box" @click="clickCalendar" >
        <span class="num">{{beginDateCpd}}</span><template v-if="privateProps.houseFilterMode!=1">入住</template>
        <div class="nights"><div class="line-through" :style="`background-color: ${privateProps.textColor};`" ></div><span class="night_text" :style="`background-color: ${privateProps.backgroundColor};border-color: ${privateProps.textColor};`">{{totalNights}}晚</span></div>
        <span class="num">{{endDateCpd}}</span><template v-if="privateProps.houseFilterMode!=1">离店</template>
        <div class="iconfont icon-solid-arrow" :style="`color: ${privateProps.textColor};`"></div>
      </div>
      <div class="hairline-border" :style="`background-color: ${privateProps.textColor};`"></div>
      <div class="booking" @click="clickBooking">
        <div class="iconfont icon-radiobox" :class="{'icon-radio-checked': showBooking}" :style="`color: ${privateProps.textColor};opacity:${!beginDate ? 0.5 : 1}`"></div>
        <span :style="`opacity: ${!beginDate ? 0.5 : 1}`">仅看可订</span>
      </div>
    </div>
    <tjb-calendar
      v-model="isShowCalendar"
      :options="calendarData"
      @dateSelectedChuanged="dateSelectedCallback"
    />
    <!-- 配置城市 -->
    <tj-popup v-model="showCityPopup" position="bottom" class="half-popup">
      <div class="popup-header"><h3>请选择地点</h3><span class="iconfont icon-close" @click="showCityPopup=false" /></div>
      <div class="content">
        <div class="city-list">
          <div
            v-for="item in compProps.mate.cityActivityParams"
            :key="item.activityId" @click="changeCity(item.activityId)"
            class="city-item"
            :class="{'active': item.activityId == houseFilter.promotionId}">
            <div>{{item.city}}</div>
          </div>
        </div>
      </div>
    </tj-popup>
    <!-- 全部城市 -->
    <tj-popup v-model="showAllCityPop" position="bottom">
      <div class="city-popup">
        <div class="popup-top tj-hairline--bottom">
          <h3>选择城市</h3>
          <div class="popup-close" @click="showAllCityPop=false">
            <tj-icon name="cross" size="16px" color="#333"/>
          </div>
        </div>
        <div class="city-content">
          <div class="hot-box">
            <div class="hot-top" id="hot">
              <img src="https://pic.tujia.com/upload/festatic/policy/TOC-1351-hot.png">
              <h4>热门城市</h4>
            </div>
            <div class="hot-content">
              <div class="hot-item f-toe" v-for="hotItem in compProps.allCityConfig.hotCityList" :key="'hot' + hotItem.cityId" @click="clickCityItem(hotItem)">
                <span>{{hotItem.cityName}}</span>
              </div>
            </div>
          </div>
          <div class="index-box">
            <div class="index-top">
              <h4>字母索引</h4>
            </div>
            <div class="index-content">
              <a class="index-item" v-for="indexItem in compProps.allCityConfig.fixedIndexList" :key="'index' + indexItem.indexText" :href="`#${indexItem.indexText}`">
                <p>{{indexItem.indexText}}</p>
              </a>
            </div>
          </div>
          <div class="city-item-box">
            <div class="city-group" v-for="groupItem in compProps.allCityConfig.cityList" :key="'cityGroup' + groupItem.group" :id="groupItem.group">
              <h4>{{groupItem.group}}</h4>
              <template v-if="groupItem.cities && groupItem.cities.length">
                <div class="city-item tj-hairline--bottom" v-for="cityItem in groupItem.cities" :key="'city' + cityItem.cityId" @click="clickCityItem(cityItem)">
                  <p>{{cityItem.cityName}}</p>
                </div>
              </template>
            </div>
          </div>
          <div class="fixed-box">
            <a class="fixed-item" href="#hot" @click="clickFixedIndex(-1)">
              <p>热门</p>
            </a>
            <a class="fixed-item" :class="{'fixed-active': fixedItem.selected}" :href="`#${fixedItem.indexText}`" v-for="(fixedItem, index) in compProps.allCityConfig.fixedIndexList" :key="'fixed' + fixedItem.indexText" @click="clickFixedIndex(index)">
              <p>{{fixedItem.indexText}}</p>
            </a>
          </div>
        </div>
      </div>
    </tj-popup>
  </section>
</template>
<script>
import moment from 'moment'
import { mapMutations, mapState } from 'vuex'
import { Toast as ToastUI } from '@tujia/tj-mob-ui'
import { Sniff } from '@/utils/q_sniff'

export default {
  name: 'ElementHouseFilterComp',
  components: {},
  data() {
    return {
      beginDate: '',
      endDate: '',
      isShowCalendar: false,
      calendarData: { beginDate: null, endDate: null, isHaiwai: false, marginTop: '0' },
      showBooking: true,
      showCityPopup: false,
      isLocationLoading: false,
      showAllCityPop: false
    }
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    isTujiaHarmony: {
      type: Boolean,
      default: false
    },
    tujiaHarmonyStatusBarHeight: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState(['houseFilter']),
    privateProps() {
      if (this.compProps.mate) {
        return this.compProps.mate.privateProps
      } else {
        return []
      }
    },
    beginDateCpd() {
      if (!this.beginDate) {
        return '— —'
      }
      const dates = this.beginDate.split('-')
      return `${dates[1]}-${dates[2]}`
    },
    endDateCpd() {
      if (!this.endDate) {
        return '— —'
      }
      const dates = this.endDate.split('-')
      return `${dates[1]}-${dates[2]}`
    },
    totalNights() {
      if (!this.beginDate || !this.endDate) {
        return '-'
      }
      return moment(this.endDate).diff(moment(this.beginDate), 'days')
    },
    cityName() {
      if (this.compProps?.mate?.privateProps?.cityChoice === 'allCity') { // 全部城市
        let currentName = ''
        this.compProps.allCityConfig.cityList && this.compProps.allCityConfig.cityList.forEach((item) => {
          item.cities.forEach((item) => {
            if (Number(item.cityId) === Number(this.houseFilter.cityId)) {
              currentName = item.cityName || ''
            }
          })
        })
        return currentName
      } else if (this.compProps?.mate?.cityActivityParams) { // 配置城市
        return this.compProps?.mate?.cityActivityParams?.find((item) => item.activityId === this.houseFilter.promotionId)?.city || ''
      } else {
        return ''
      }
    }
  },
  created() {
    let defaultBlankDate = this.compProps?.mate?.privateProps?.defaultBlankDate
    this.beginDate = this.houseFilter.checkInDate ? this.houseFilter.checkInDate : (defaultBlankDate ? null : moment().format('YYYY-MM-DD'))
    this.endDate = this.houseFilter.checkOutDate ? this.houseFilter.checkOutDate : (defaultBlankDate ? null : moment().add(1, 'day').format('YYYY-MM-DD'))
    let useAvailable = this.compProps?.mate?.privateProps?.useAvailable === undefined ? true : this.compProps?.mate?.privateProps?.useAvailable
    this.showBooking = this.houseFilter.onlyCanBooking === '' ? useAvailable : this.houseFilter.onlyCanBooking
    this.setVisible(true)
    this.setCheckInDate(this.beginDate)
    this.setCheckOutDate(this.endDate)
    this.setOnlyBooking(this.showBooking)
    this.initDate()
    const { cityId } = this.$route.query
    // 全部城市，设置默认城市id
    if (this.compProps?.mate?.privateProps?.cityChoice === 'allCity' && (cityId || this.compProps?.mate?.privateProps?.defaultCityId)) {
      // URL带了城市过来就用 URL的城市
      this.setCityId(Number(cityId || this.compProps?.mate?.privateProps?.defaultCityId))
    } else {
      this.setCityId('')
    }
    // TTJ-19495 合规需求先下掉
    // if (this.compProps?.mate?.privateProps?.houseFilterMode === '1') {
    //   if (this.houseFilter.isLoading) {
    //     this.getMyPosition()
    //   } else {
    //     this.isLocationLoading = false
    //   }
    // }
  },
  mounted() {
  },
  methods: {
    ...mapMutations(['setVisible', 'setCheckInDate', 'setCheckOutDate', 'setOnlyBooking', 'setPromotionId', 'setIsLoading', 'setCityId']),
    setZeroTime(dateString = null) {
      const date = new Date(dateString)
      date.setHours(0)
      date.setMinutes(0)
      date.setSeconds(0)
      return date
    },
    initDate() {
      this.calendarData.beginDate = this.setZeroTime(this.beginDate)
      this.calendarData.endDate = this.setZeroTime(this.endDate)

      if (Sniff.isHarmonyWithoutAdr || this.isTujiaHarmony) {
        const statusBarHeight = Sniff.isHarmonyWithoutAdr ? (Sniff.immersiveOffset || 0) : this.tujiaHarmonyStatusBarHeight
        this.calendarData.marginTop = statusBarHeight + 'px'
      }
    },
    clickLocation() {
      // 全部城市，出半层
      if (this.compProps?.mate?.privateProps?.cityChoice === 'allCity') {
        this.showAllCityPop = true
      } else { // 配置城市，走跳转活动页逻辑
        this.showCityPopup = true
      }
    },
    clickCalendar() {
      this.isShowCalendar = true
    },
    dateSelectedCallback(beginDate, endDate) {
      this.beginDate = moment(beginDate).format('YYYY-MM-DD')
      this.endDate = moment(endDate).format('YYYY-MM-DD')
      this.calendarData.beginDate = beginDate
      this.calendarData.endDate = endDate

      this.setCheckInDate(this.beginDate)
      this.setCheckOutDate(this.endDate)
    },
    clickBooking() {
      if (!this.beginDate) {
        ToastUI('请先选择入住日期')
        return
      }
      this.showBooking = !this.showBooking
      this.setOnlyBooking(this.showBooking)
    },
    changeCity(activityId) {
      this.setPromotionId(activityId)
      this.$emit('reload', activityId, false)
      this.showCityPopup = false
    },
    // changeLocation() {
    //   this.setIsLoading(false)
    // },
    // getMyPosition() {
    //   getCurrentPostion((isSuccess, data, err) => {
    //     if (isSuccess) {
    //       if (this.houseFilter.isLoading) {
    //         this.isLocationLoading = true
    //         const { lat, lng } = data
    //         this._getGeoInfo({ latitude: lat, longitude: lng, coordType: 2 }, false)
    //       } else {
    //         this.isLocationLoading = false
    //       }
    //     } else {
    //       this.isLocationLoading = false
    //       this.changeLocation()
    //     }
    //   })
    // },
    // async _getGeoInfo(geo, isIp) {
    //   const geoInfo = await geoData(geo)
    //   this.isLocationLoading = false
    //   this.changeLocation()
    //   if (geoInfo.ret) {
    //     let data = geoInfo.data
    //     if (data.cityName && this.compProps.mate && this.compProps.mate.cityActivityParams) {
    //       let cityActivityObj = this.compProps?.mate?.cityActivityParams?.find((item) => item.city === data.cityName) || {}
    //       let actId = cityActivityObj.activityId || ''
    //       if (actId && actId !== this.houseFilter.promotionId) {
    //         this.changeCity(actId)
    //       }
    //     }
    //   }
    // },
    clickCityItem(cityItem) {
      this.showAllCityPop = false
      this.compProps.allCityConfig && this.compProps.allCityConfig.fixedIndexList && this.compProps.allCityConfig.fixedIndexList.forEach((item) => { item.selected = false })
      if (this.privateProps.cityJumpType === 'listPage' && cityItem) { // 跳转到L页
        this.$emit('action', { type: 'jumpPage', data: { cityItem: cityItem } })
      } else { // 请求房屋列表
        this.setCityId(Number(cityItem.cityId))
      }
    },
    // 定位索引
    clickFixedIndex(fixedItemIndex) {
      this.compProps.allCityConfig && this.compProps.allCityConfig.fixedIndexList && this.compProps.allCityConfig.fixedIndexList.forEach((item) => { item.selected = false })
      if (fixedItemIndex >= 0 && this.compProps.allCityConfig.fixedIndexList) {
        this.compProps.allCityConfig.fixedIndexList[fixedItemIndex].selected = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@function size($n) {
  @return $n/375 * 100vw;
}
.filter_wrapper {
  padding: 0 size(15) size(6);
}
.filter-bar {
  height: size(40);
  display: flex;
  justify-content: space-between;
  border-radius: 6px;
  background: #aaa;
  color: #fff;
  align-items: center;
  font-size: 13px;
  padding: 0 size(24);
  &.hascity {
    padding: 0 size(16);
  }
  .hairline-border {
    height: size(32);
    width: 1px;
    background-color: #fff;
    box-sizing: border-box;
    -webkit-transform: scale(.5);
    transform: scale(.5);
  }
  .booking {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    .icon-radiobox {
      font-size: 14px;
      margin-right: 4px;
    }
  }
  .icon-solid-arrow {
    font-size: 10px;
    margin-left: 3px;
  }
  .date-box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-family: PingFangSC-Light;
    font-size: 12px;
    .num {
      font-family: TujiaFont-Number;
      font-size: size(13);
      margin-right: 3px;
    }
    .nights {
      display: flex;
      align-items: center;
      justify-content:center;
      position: relative;
      padding: 0 4px;
      margin: 0 size(6);
      .line-through {
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -1px;
        width: 100%;
        height: 1px;
        background-color: #fff;
        z-index: 0;
      }
      .night_text {
        box-sizing: border-box;
        position: relative;
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content:center;
        height: size(15);
        border: 1px solid rgba(255,255,255,1);
        border-radius: size(7.5);
        padding: 0 size(6);
        font-family: PingFangSC-Medium;
        font-size: size(10);
        padding-top: 1px;
      }
    }
  }
  .city-field {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    .city-name {
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: size(52);
      overflow: hidden;
    }
  }
}
.half-popup {
  min-height: calc(100vh * .4);
  max-height: calc(100vh * .8);
  border-radius: 12px 12px 0px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  overflow: hidden;
  .popup-header {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    flex-shrink: 0;
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    h3 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: bold;
    }
    .icon-close {
      position: absolute;
      right: 16px;
      top: 15px;
      font-size: 18px;
      color: #666666;
    }
  }
  .content {
    flex: 1;
    overflow-y: auto;
    width: 100%;
  }
  .city-list {
    display: flex;
    flex-wrap: wrap;
    padding: size(8) size(13);
    .city-item {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      width: size(81);
      height: size(40);
      margin: 0 size(3) size(6);
      padding: 0 size(8);
      background: #F4F6F9;
      border-radius: 4px;
      color: #333333;
      &>div{
        max-height: size(28);
        justify-content: center;
        font-size: 12px;
        line-height: 14px;
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
      }
      &.active{
        background: #FFFCFA;
        border: 0.5px solid #FF6E16;
        color: #FF6E16;
        font-family: PingFangSC-Medium;
      }
    }
  }
}
.tj-channel-ctrip {
  .city-list .city-item.active{
    background: #E6F3FE;
    color: #0086F6;
    border:0;
  }
}
.tj-popup {
  border-radius: 12px 12px 0 0;
  min-height: 40vh;
  .popup-top {
    height: 48px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    h3 {
      font-size: 18px;
      color: #333;
      font-weight: bold;
    }
    .popup-close {
      height: 18px;
      width: 18px;
      position: absolute;
      top: 15px;
      right: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.city-popup {
  .city-content {
    max-height: calc(80vh - 48px);
    min-height: calc(40vh - 48px);
    padding: 16px;
    overflow: scroll;
    position: relative;
    .hot-box {
      margin-bottom: 12px;
      .hot-top {
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        font-weight: bold;
        img {
          height: 18px;
          width: 18px;
          margin-right: 6px;
        }
      }
      .hot-content {
        display: flex;
        flex-wrap: wrap;
        .hot-item {
          width: 22%;
          min-height: 40px;
          background: #F4F6F9;
          border-radius: 4px;
          margin-right: 8px;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #333;
          padding: 0 8px;
          span {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .index-box {
      margin-bottom: 4px;
      .index-top {
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        font-weight: bold;
      }
      .index-content {
        display: flex;
        flex-wrap: wrap;
        .index-item {
          width: 10%;
          height: 34px;
          background: #F4F5F6;
          border-radius: 4px;
          margin-right: 8px;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #333
        }
      }
    }
    .city-item-box {
      .city-group {
        font-size: 14px;
        color: #333333;
        h4 {
          height: 36px;
          display: flex;
          align-items: center;
          font-weight: bold;
        }
        .city-item {
          height: 44px;
          display: flex;
          align-items: center;
        }
      }
    }
    .fixed-box {
      width: 25px;
      position: fixed;
      top: 90px;
      right: 4px;
      font-size: 10px;
      color: #FF6E16;
      display: flex;
      flex-direction: column;
      align-items: center;
      .fixed-item {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FF6E16;
        padding: 0 2px;
        border-radius: 8px;
        min-width: 16px;
        height: 16px;
        margin-bottom: 5px;
        &.fixed-active {
          background-color: #FF6E16;
          color: #fff;
        }
      }
    }
  }
}
</style>
